import { Form, Select, Switch } from 'antd-v5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SettingsContent } from '../../../components/SettingsContent';
import DescriptionBox from '../../../../../../components/Layout/DescriptionBox';
import TextAreaWithActions from '../../../../../../components/Layout/TextAreaWithActions';

export const MessagingSettings = ({ form, stores, fileData, fileDispatch }) => {
  const sendWelcomeMessage = Form.useWatch('sendWelcomeMessage', form);

  return (
    <SettingsContent title="MESSAGING" icon={<FontAwesomeIcon icon={['far', 'messages']} />} className="w-100-P">
      <DescriptionBox
        className="w-100-P"
        title="Default Store to Receive In-bound Webchat Messages"
        description="When an unrecognized number messages your store using Clientbook's webchat, which location should receive it?"
        input={
          <Form.Item name="defaultStore">
            <Select
              style={{ minWidth: '200px' }}
              popupMatchSelectWidth={false}
              placeholder="Not Set"
              options={stores?.filter(st => !!st?.id).map(store => ({ value: store.id, label: store.name }))}
            />
          </Form.Item>
        }
      />
      <DescriptionBox
        className="w-100-P"
        title="Auto Message Scheduled Time"
        description="When should auto messages begin sending each day?"
        input={
          <Form.Item name="setSchTime">
            <Select
              style={{ minWidth: '200px' }}
              popupMatchSelectWidth={false}
              options={[
                { label: '9:00 AM', value: '0900' },
                { label: '10:00 AM', value: '1000' },
                { label: '11:00 AM', value: '1100' },
                { label: '12:00 PM', value: '1200' },
                { label: '1:00 PM', value: '1300' },
                { label: '2:00 PM', value: '1400' },
                { label: '3:00 PM', value: '1500' },
                { label: '4:00 PM', value: '1600' },
                { label: '5:00 PM', value: '1700' },
              ]}
              placeholder="Schedule runtime"
            />
          </Form.Item>
        }
      />
      <DescriptionBox
        className="w-100-P"
        title="Automatically close conversations"
        description="This allows you to close conversations automatically that have gone longer than a specified time without inbound or outbound messages."
        input={
          <Form.Item name="autoCloseTime">
            <Select
              style={{ minWidth: '200px' }}
              popupMatchSelectWidth={false}
              options={[
                { label: '2 Weeks', value: 14 },
                { label: '30 days', value: 30 },
                { label: '60 days', value: 60 },
                { label: '90 days', value: 90 },
              ]}
              placeholder="Select time period"
            />
          </Form.Item>
        }
      />
      <DescriptionBox
        className="w-100-P"
        title="Review Link Template"
        description="Customize the review link template message that is shown in a client conversation."
        input={
          <>
            <TextAreaWithActions
              containerStyleProps={{ border: '1px solid #d9d9d9', borderRadius: '6px', width: '100%' }}
              id="ReviewLinkTemplateInput"
              val={form.getFieldValue('reviewMessage')}
              changeHandler={value => form.setFieldValue('reviewMessage', value)}
              placeholder=":name:, would you be willing to take 30 seconds to leave us a review using the link below? Let me know how I can help in the future. :review:"
              fileData={fileData}
              fileDispatch={fileDispatch}
              template
              associate=":associate:"
              reviewMessage={form.getFieldValue('reviewMessage') || ' '}
            />
            <Form.Item name="reviewMessage" noStyle />
          </>
        }
      />
      <DescriptionBox
        className="w-100-P"
        title="Send Welcome Message After Adding a New Client"
        description="When enabled, the Kiosk will automatically send a welcome message to new clients when they are added."
        input={
          <Form.Item name="sendWelcomeMessage" valuePropName="checked">
            <Switch />
          </Form.Item>
        }
      />
      {sendWelcomeMessage && (
        <DescriptionBox
          className="w-100-P"
          title="Welcome Message"
          description="Customize the welcome message sent to clients when they are added via the Kiosk."
          input={
            <>
              <TextAreaWithActions
                containerStyleProps={{ border: '1px solid #d9d9d9', borderRadius: '6px', width: '100%' }}
                id="WelcomeMessageInput"
                val={form.getFieldValue('welcomeMessage')}
                changeHandler={value => form.setFieldValue('welcomeMessage', value.length > 255 ? value.substring(0, 255) : value)}
                placeholder="Hello :name:, this is :associate:. I look forward to personally assisting you. Anything you need is just a text away."
                maxLength={255}
                template
                associate=":associate:"
                showMerchantName
                reviewMessage={form.getFieldValue('welcomeMessage') || ' '}
              />
              <Form.Item name="welcomeMessage" noStyle />
            </>
          }
        />
      )}
      <DescriptionBox
        className="w-100-P"
        title="Decluttered Inbox"
        description="Enabling this setting allows you and your associates the ability to close conversations."
        input={
          <Form.Item name="declutteredInbox" valuePropName="checked">
            <Switch />
          </Form.Item>
        }
      />
      {stores?.filter(st => st.id !== 0).length > 1 && (
        <DescriptionBox
          className="w-100-P"
          title="View conversation history from all stores"
          description={
            <>
              Turning this toggle on will set the conversation view to see all stores conversations with a client in
              <br />
              the thread. Turning it off will set the view to only see the conversations with a client from the inbox
              <br />
              you're in.
            </>
          }
          input={
            <Form.Item name="allStoreConversationHistory" valuePropName="checked">
              <Switch />
            </Form.Item>
          }
        />
      )}
    </SettingsContent>
  );
};
